import * as Scrivito from "scrivito"

export const Image = Scrivito.provideObjClass("Image", {
  attributes: {
    blob: "binary",
    tags: "stringlist",
    alternativeText: "string",
    title: "string",
    md5Hash: "string",
    externalId: "string",
    externalLastChanged: "string"
  }
})

export type ImageObj = InstanceType<typeof Image>

export default Image

export function isImage(input: unknown): input is ImageObj {
  return input instanceof Image
}
